var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiplechoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-list-todo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 6,
    height: 6,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 17 2 2 4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6h8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12h8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18h8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplechoice);
export default __webpack_public_path__ + "static/media/multiplechoice.65d9659a9b4544f0b6a4a18621896fe4.svg";
export { ForwardRef as ReactComponent };